import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllvalueAdditionFourResponse, ValueAdditionFourDto, valueAdditionFourResponse, ValueAdditionIdModel, valueAdditionIdResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { ValueAddFourTypeAdapter } from './dto/value-addition-four.adapter';
import { ValueAdditionFourDTO } from './dto/value-addition-four.dto';
import { ValueAdditionFourRequest } from './dto/value-addition-four.request';
import { ValueAdditionFourType } from './value-addition-four.entity';

@Injectable()
export class ValueAddition4TypesService {
  getAllActiveValAddTypes(): AllvalueAdditionFourResponse | PromiseLike<AllvalueAdditionFourResponse> {
    throw new Error('Method not implemented.');
  }
    constructor(
      private logService:LogsService,

        @InjectRepository(ValueAdditionFourType) private foodTypeRepository: Repository<ValueAdditionFourType>,
        private valAddFourAdapter: ValueAddFourTypeAdapter,
      ) { }

    //create method
      async createValAddFourType(valAddDto:ValueAdditionFourDTO,isUpdate:boolean,@Req() request:Request): Promise<valueAdditionFourResponse> {
        try {
        let previousValue;
        if (!isUpdate) {
   
            const valAddFourTypeEntity = await this.getDuplicateValAddFourType(valAddDto.code);
          if (valAddFourTypeEntity) {
            throw new valueAdditionFourResponse(false,11104, 'Value Addition Type already exists');
          }
        }
        else {
            const certificatePrevious = await this.foodTypeRepository.findOne({where:{valueAdditionFourId:valAddDto.valueAdditionFourId}})
            previousValue = certificatePrevious.name+','+certificatePrevious.code;
            const valAddFourTypeEntity = await this.getDuplicateValAddFourType(valAddDto.code);
          if (valAddFourTypeEntity) {
              if(valAddFourTypeEntity.valueAdditionFourId != valAddDto.valueAdditionFourId){
                throw new valueAdditionFourResponse(false,11104, 'Value Addition Type already exists');
              }
          }
        }
        const convertedvalAddTypeEntity: ValueAdditionFourType = this.valAddFourAdapter.convertDtoToEntity(valAddDto,isUpdate);
        const savedValAddEntity: ValueAdditionFourType = await this.foodTypeRepository.save(convertedvalAddTypeEntity);
        const savedValAddTypeDto: ValueAdditionFourDTO = this.valAddFourAdapter.convertEntityToDto(savedValAddEntity);
       
         if (savedValAddTypeDto) {
            const present = savedValAddTypeDto.code+','+savedValAddTypeDto.name
          const response = new valueAdditionFourResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Value Addition  Type Updated Successfully':'Value Addition  Type Created Successfully',savedValAddTypeDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'Value Addition Four Type Updated Successfully': 'Value Addition Four Type Created Successfully'
            const userName = isUpdate? savedValAddTypeDto.updatedUser :savedValAddTypeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'ValueAdditionFourDTO', savedValAddTypeDto.valueAdditionFourId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new valueAdditionFourResponse(false,11106,'Value Addition Four Type saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
        async getAllValAddFourTypes(req?:UserRequestDto): Promise<AllvalueAdditionFourResponse> {  
            try {
                const valAddDto: ValueAdditionFourDto[] = [];
                // retrieves all plants
                const valAddOneTypeEntities: ValueAdditionFourType[] = await this.foodTypeRepository.find({
                    order: { name: "ASC" },
                });
                //   console.log(valAddOneTypeEntities);
                if (valAddOneTypeEntities.length>0) {
                    valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                    const convertedValAddTypeDto: ValueAdditionFourDto = this.valAddFourAdapter.convertEntityToDto(valAddOneTypeEntity);
                    valAddDto.push(convertedValAddTypeDto);
                    });
                    const response = new AllvalueAdditionFourResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                    if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'ValueAdditionFourDTO', 0, true, 'Value Addition Types retrieved successfully',req.createdUser)
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                    }
                    return response;
                } else {
                    //   console.log('yest')
                    throw new valueAdditionFourResponse(false,99998, 'No Records Found');
                }
        } catch (err) {
        throw err;
        }
    }
    async getAllActiveValAddFourTypes(): Promise<AllvalueAdditionFourResponse> {
        // const page: number = 1;
        try {
            const valAddDto: ValueAdditionFourDto[] = [];
            //retrieves all companies
            const valAddOneTypeEntities: ValueAdditionFourType[] = await this.foodTypeRepository.find({ order: { name: 'ASC' },where:{isActive:true},
           });
         console.log(valAddOneTypeEntities)
            if (valAddOneTypeEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                    const convertedValAddTypeDto: ValueAdditionFourDto = this.valAddFourAdapter.convertEntityToDto(
                        valAddOneTypeEntity
                    );
                    valAddDto.push(convertedValAddTypeDto);
                });
                const response = new AllvalueAdditionFourResponse(true, 11108, "ValAddFourTypes retrieved successfully", valAddDto);
                return response;
            } else {
                throw new valueAdditionFourResponse(false,99998, 'Data not found'); valAddDto
            }
        } catch (err) {
            throw err;
        }
    }

    /**
     * It deactivates value addition value  type 
     * @param foodTypeRequest addition  type  as string
     * @returns true or false
     */
    //  @LogActions({isAsync: true})
     async activateOrDeactivateValAddFourType(valAddOneReq: ValueAdditionFourRequest): Promise<valueAdditionFourResponse> {
         try {
             const FoodTypeExists = await this.getValAddTypeById(valAddOneReq.valueAdditionFourId);
             if (FoodTypeExists) {
                 if (valAddOneReq.versionFlag !== FoodTypeExists.versionFlag) {
                     throw new valueAdditionFourResponse(false,10113, 'Someone updated the current Value Addition Type information.Refresh and try again');
                 } else {
                     
                         const foodTypeSatatus =  await this.foodTypeRepository.update(
                             { valueAdditionFourId: valAddOneReq.valueAdditionFourId },
                             { isActive: valAddOneReq.isActive,updatedUser: valAddOneReq.updatedUser });
                        
                         if (FoodTypeExists.isActive) {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionFourResponse = new valueAdditionFourResponse(true, 10115, 'Value Addition Type is de-activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionFourResponse(false,10111, 'Value addition Type is already deactivated');
                             }
                         } else {
                             if (foodTypeSatatus.affected) {
                                 const foodTypeResponse: valueAdditionFourResponse = new valueAdditionFourResponse(true, 10114, 'Value addition type is activated successfully');
                                 return foodTypeResponse;
                             } else {
                                 throw new valueAdditionFourResponse(false,10112, 'Value addition type is already  activated');
                             }
                         }
                     // }
                 }
             } else {
                 throw new valueAdditionFourResponse(false,99998, 'No Records Found');
             }
         } catch (err) {
             throw err;
         }
     }

    async getValAddFourType(valAddFourId: number): Promise<ValueAdditionFourType> {
    //  console.log(employeeId);
        const response = await this.foodTypeRepository.findOne({
        where: {valueAdditionFourId: Raw(alias => `value_addition_four_id = '${valAddFourId}'`)},
        });
        // console.log(response);valueAdditionOneId: Raw(alias => `value_addition_one_id = '${valueAdditionOneId}'`)
        if (response) {
        return response;
        } else {
        return null;
        }
    }

    async getDuplicateValAddFourType(valAddFourCode: string): Promise<ValueAdditionFourType> {
        //  console.log(employeeId);
            const response = await this.foodTypeRepository.findOne({
            where: {valueAdditionFourId: Raw(alias => `code = '${valAddFourCode}'`)},
            });
            // console.log(response);valueAdditionOneId: Raw(alias => `value_addition_one_id = '${valueAdditionOneId}'`)
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    async getValAddTypeById(valueAdditionId: number): Promise<ValueAdditionFourType> {
        //  console.log(employeeId);
            const Response = await this.foodTypeRepository.findOne({
            where: {valueAdditionFourId: valueAdditionId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     */
    async getValAddDetails(valueAdditionId: number): Promise<valueAdditionIdResponse> {
        const valAddData = await this.foodTypeRepository.findOne({select: ['name','code'], where: {valueAdditionFourId: valueAdditionId}});
        if(valAddData) {
            const modelResponse = new ValueAdditionIdModel(valAddData.name, valAddData.code);
            const response = new valueAdditionIdResponse(true, 11208, "Value Addition Types retrieved successfully", modelResponse);
            return response;
        } else {
            return null;
        }   
    }    
}
